import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot, Data, NavigationStart, Router, RouterStateSnapshot } from '@angular/router';

import { Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RouterStateResolverService  implements OnDestroy {
    private readonly subscription: Subscription;

    private state: Data = {};
    public state$: Observable<Data>;

    constructor(private router: Router) {
        this.state$ = this.router.events.pipe(
            filter(event => event instanceof NavigationStart),
            map(() => this.router.getCurrentNavigation()?.extras.state ?? {})
        );

        this.subscription = this.state$.subscribe(state => {
            this.state = state;
        });
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Data {
        return this.state ?? {};
    }
}
